import axios from 'axios'
export const mixins = {
  data() {
    return {
      isShowing: false
    }
  },
  methods: {
    showAuthView(name) {
      const auth = this.getSpaceToggle ? Object.values(this.getAuth) : this.getAuth[this.$route.meta.storeKey]
      return auth && auth.includes(name)
    },
    async mockAjax(url, data) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: '/mock' + url,
          data
        }).then(res => {
          resolve(res.data)
        }).catch(err => {
          this.$vux.loading.hide()
          reject(err)
        })
      })
    },
    getAjax(url, data, config = {}) {
      return new Promise((resolve, reject) => {
        this.$axios.get(url, { params: data, ...config }).then(res => {
          if (res.code === 0 || res.code == 200) {
            resolve(res)
          } else if (res.code === 4000) {
            resolve(res)
          } else {
            this.$toast.failed(res.msg)
            this.$vux.loading.hide()
            reject(res)
          }
        }).catch(err => {
          this.$vux.loading.hide()
          reject(err)
        })
      })
    },
    async postAjax(url, data, config = {}) {
      return new Promise((resolve, reject) => {
        this.$axios.post(url, data, { ...config }).then(res => {
          if (res.code === 0 || res.code == 200 || res.code == '00000000') {
            resolve(res)
          } else if (res.code === 4000) {
            resolve(res)
          } else {
            this.$toast.failed(res.msg)
            this.$vux.loading.hide()
            reject(res)
          }
        }).catch(err => {
          this.$vux.loading.hide()
          reject(err)
        })
      })
    },
    blur() {
      this.$refs.cont.style.height = 'auto'
    },
    focus() {
      setTimeout(() => {
        const contHeight = document.body.scrollHeight
        const clientHeight = document.body.clientHeight
        this.$refs.cont.style.height = contHeight + clientHeight / 1.5 + 'px'
        const target = arguments[1].target
        target.scrollIntoView({ block: 'center' })
        const sy = window.scrollY
        window.scrollTo(0, sy - document.body.clientHeight / 10)
      }, 100)
    },
    setOptions(data, props) {
      const arr = [{ text: '全部', value: '' }]
      data.forEach(item => {
        const obj =
        {
          text: item[props.label],
          value: item[props.value]
        }
        arr.push(obj)
      })
      return arr
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/index.js